export const HERE_API_KEY= process.env.HERE_API_KEY;
export const TILES_BASE_URI = process.env.TILES_BASE_URI;
export const GTAG_KEY = process.env.GTAG_KEY;
export const RAILS_ENVIRONMENT = process.env.RAILS_ENVIRONMENT;
